module.exports = __webpack_public_path__ + "static/media/BannerD9.2d06bc3a.png";